export const padIndex = (index: number | string, total: number): string => {
  const digits = Math.ceil(Math.log10(total));
  return String(index).padStart(digits, "0");
};
